<template>
  <base-edit :fields="fields"
             :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
  </base-edit>
</template>

<script>

export default {
  components: {
  },
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const commonColumns =[
      {
        label: "お知らせタイトル",
        name: "title",
        rules: "required|max:255",
        width: "100%"
      },
      {
        label: "お知らせ本文",
        name: "body",
        type: "textarea",
        rules: "required",
        width: "100%"
      },
      {
        label: "お知らせ公開(予定)日時",
        name: "publish_at",
        type: "display",
        rules: "",
        width: "60%"
      },
      {
        label: "公開/非公開ステータス",
        name: "published",
        type: "checkbox",
        textKey: "label",
        valueKey: "value",
        selects: [
          {
            label: "公開",
            value: 1
          }

        ]
      },
      {
        label: "配信ユーザー指定(絞込)",
        name: "conditions",
        type: "conditions"
      },
      {
        label: "Push通知する",
        name: "push_notification",
        type: "checkbox",
        textKey: "label",
        valueKey: "value",
        selects: [
          {
            label: "通知する",
            value: 1
          }
        ]
      }
    ];

    return {
      resourceName: "news",
      fields: commonColumns
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "お知らせ一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "お知らせ編集",
          disabled: true
        }
      ];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  }

};
</script>
